import {ChangeDetectorRef, Component, Input, OnChanges, ViewEncapsulation} from '@angular/core';
import {Browser, browserFromBackendObject} from '../../types/browser';
import {LogoResolverService} from '@webmate-web-core/shared/services/logo-resolver.service';

@Component({
    selector: 'wm-browser',
    templateUrl: './browser.component.html',
    styleUrls: ['./browser.component.less'],
    encapsulation: ViewEncapsulation.None

})
export class BrowserComponent implements OnChanges {

    @Input() browser: Browser;
    @Input() displaySmall: boolean = false;
    @Input() displayWithSmallerLogo: boolean = false;
    @Input() displayWithPadding: boolean = false;
    @Input() showLabels: boolean = true;
    @Input() showPlatform: boolean = true;
    @Input() tooltipLocation: string = "right";
    @Input() noTooltip: boolean = false;
    @Input() displayInline: boolean = false;

    @Input() additionalData: any = undefined; //any data, is displayed after the Browser
    @Input() additionalIcon?: string = undefined;

    displayBrowser: Browser;
    fallBackLogo = '/assets/img/questionmark.png';

    logoUrl: string;

    constructor(private browserUrlResolver: LogoResolverService, private cdRef: ChangeDetectorRef) {}

    ngOnChanges() {
        // ensure that the browser object has been properly converted
        if (this.browser && !this.browser['isSupportedByCapabilities']) {
            this.displayBrowser = browserFromBackendObject(this.browser)!;
        } else {
            this.displayBrowser = this.browser;
        }
        this.logoUrl = this.fallBackLogo;
        if (this.displayBrowser) {
            this.browserUrlResolver.getLogoForBrowser(this.displayBrowser).subscribe(logoUrl => {
                this.logoUrl = logoUrl;
                this.cdRef.markForCheck();
            });
        }
    }

    getTooltip() {
        if (!this.noTooltip && this.displayBrowser?.capabilities) {
            const caps = this.displayBrowser.capabilities;
            let webdriver = caps["selenium.webdriverSupport"] ? " with Webdriver Support " : "";
            let browserMob = caps["service.browserMobSupport"] ? " with BrowserMob Support " : "";
            let locale = caps["browser.locale"] ? " " + caps["browser.locale"] : "";
            const name = this.showPlatform
                ? this.displayBrowser.getFullName()
                : `${this.displayBrowser.browserType} ${this.displayBrowser.version}`;
            return name + locale + webdriver + browserMob;
        }
        return "";
    }

    logoLoaded() {
        // If the browser is embedded in a ChangeDetection.OnPush context, refresh the logo when its loaded
        this.cdRef.markForCheck();
    }
}
